export default __webpack_public_path__ + "static/media/FacebookWhite.0ac661ac.svg";